/**
 * Implements a single trending item
*/
import { useCallback } from 'react';
import { ITrendingItem } from '@kattana-io/common';
import Text from '../../../atoms/Text';
import { toFixed2 } from '../../DexTrades/formatters';
import { switchCurrentTicker } from '../../../Authlogic';

interface IProps {
  item: ITrendingItem;
}

const TrendingCoinMobile = ({ item }: IProps) => {
  const { label, link, price, ticker } = item;

  const onTickerClick = useCallback(() => {
    if (ticker) {
      switchCurrentTicker(ticker);
    }
  }, [ticker]);

  if (ticker) {
    return (
      <div className='trending__mobile__items__item' onClick={onTickerClick}>
        <div className='trending__mobile__items__item__coin'>
          <Text size={14}>{label}</Text>
        </div>
        <div className='trending__mobile__items__item__price'>
          <Text size={14}>${toFixed2(ticker.flipped ? ticker.price_b_usd : ticker.price_a_usd)}</Text>
        </div>
      </div>
    );
  }

  return (
    <a className='trending__mobile__items__item' href={link}>
      <div className='trending__mobile__items__item__coin'>
        <Text size={14}>{label}</Text>
      </div>
      <div className='trending__mobile__items__item__price'>
        <Text size={14}>${price?.toFixed(2)}</Text>
      </div>
    </a>
  );
};

export default TrendingCoinMobile;
